module.exports = __webpack_public_path__ + "img/tip.1cf119da.png";